import script from "./CustomerRemarksModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerRemarksModal.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerRemarksModal.vue?vue&type=style&index=0&id=5b9af405&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b9af405"]])

export default __exports__